/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  WBANGaslessSwap,
  WBANGaslessSwapInterface,
} from "../../contracts/WBANGaslessSwap";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RELAYER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wBAN",
        type: "address",
      },
      {
        internalType: "address payable",
        name: "_swapTarget",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "swapTarget",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "sellAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "swapCallData",
        type: "bytes",
      },
    ],
    name: "swapWBANToCrypto",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "wBAN",
    outputs: [
      {
        internalType: "contract WBANTokenWithPermit",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type WBANGaslessSwapConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WBANGaslessSwapConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class WBANGaslessSwap__factory extends ContractFactory {
  constructor(...args: WBANGaslessSwapConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<WBANGaslessSwap> {
    return super.deploy(overrides || {}) as Promise<WBANGaslessSwap>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): WBANGaslessSwap {
    return super.attach(address) as WBANGaslessSwap;
  }
  override connect(signer: Signer): WBANGaslessSwap__factory {
    return super.connect(signer) as WBANGaslessSwap__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WBANGaslessSwapInterface {
    return new utils.Interface(_abi) as WBANGaslessSwapInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WBANGaslessSwap {
    return new Contract(address, _abi, signerOrProvider) as WBANGaslessSwap;
  }
}
